import { render, staticRenderFns } from "./ReportDetailsCardContent.vue?vue&type=template&id=65f26cd9"
import script from "./ReportDetailsCardContent.vue?vue&type=script&lang=js"
export * from "./ReportDetailsCardContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports